import { httpClient } from "./httpClient";
import { getToken, getUserName } from "../Common/utils/auth";
import { BASE_URL } from "../Common/constant"; // Assuming BASE_URL is still needed for direct axios calls if any remain, otherwise remove.
import axios from "axios"; // Assuming axios is still needed for direct calls if any remain, otherwise remove.

export const fetchPendingConsmer = async () => {
    try {
        const result = await axios.post(BASE_URL + "agent/pendingcustomer", {},
            {
                headers: {
                    encryption: false,
                    token: getToken()
                },
            });
        return result.data.data.data;
    } catch (error) {
        console.log("error", error);
        throw error;
    }
};

export const fetchNewConsumer = async () => {
    try {
        const result = await axios.post(
            BASE_URL + "agent/onlyconsumer",
            {},
            {
                headers: {
                    encryption: false,
                    token: getToken(),
                },
            }
        );
        return result.data.data.data;
    } catch (error) {
        console.log("error", error);
        throw error;
    }
};

export const manageSingleAadhaar = async () => {
    try {
        const result = await axios.post(
            BASE_URL + "agent/onlyconsumer",
            {},
            {
                headers: {
                    encryption: false,
                    token: getToken(),
                },
            }
        );
        return result.data.data.data;
    } catch (error) {
        console.log("error", error);
        throw error;
    }
};

export const manageDoubleAadhaar = async () => {
    try {
        const result = await axios.post(
            BASE_URL + "agent/onlyconsumer",
            {},
            {
                headers: {
                    encryption: false,
                    token: getToken(),
                },
            }
        );
        return result.data.data.data;
    } catch (error) {
        console.log("error", error);
        throw error;
    }
};

export const fetchDashBoard = async () => {
    try {
        const result = await httpClient("customer/customerbyagent", "POST", {});
        return result.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const fetchAllCustomer = async () => {
    try {
        const result = await httpClient("agent/allconsumer", "POST", {});
        return result.data.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const svreadylistFun = async () => {
    try {
        const result = await httpClient("agent/svreadylist", "POST", { mainAgent: getUserName() });
        return result.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};